import {Component} from "@angular/core";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {EmployeeEntityModel} from "../../employee-entity.model";

@Component({
    selector: "wbo-employee-edit-employment",
    templateUrl: "./employee-edit-employment.component.html"
})
export class EmployeeEditEmploymentComponent {
    constructor(public model: EmployeeEntityModel, public editService: EditService) {
    }
}
